module.exports = __webpack_public_path__ + "static/media/implant.86e13d32.svg";